// The one door onto §4.12 Stock Adjustment from every other screen (spec 06
// §4.12, D-315): §4.1's head and bulk rows, §4.3's pane and loose rows,
// §4.6's head and stock rows, §4.11's head, and spec 04's S2 and S7
// stock-adjustment sentences.
//
// Shown ONLY to a reader the client mirror resolves to `inventory.adjust`
// (fail-closed — hooks/permissions.ts). A reader without it keeps the screen
// it is on unchanged, with no entry and no dead link: the form would only
// show them ForbiddenState. The server stays the boundary either way.

import { Link } from "@tanstack/react-router";
import type { AdjustSearch } from "../screens/search-params";
import { useInventoryPermissions } from "../hooks/permissions";

export function AdjustStockLink({
  search,
  label,
  testId,
}: {
  search: AdjustSearch;
  label: string;
  testId?: string | undefined;
}) {
  const perms = useInventoryPermissions();
  if (!perms.has("inventory.adjust")) return null;
  return (
    <Link
      to="/inventory/adjust"
      search={search}
      className="ds-lnk"
      data-testid={testId ?? "adjust-stock-link"}
    >
      {label}
    </Link>
  );
}
